import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { finalize, Observable } from 'rxjs';
import { Country } from '../models/country.model';
import { GeneralSpecialty } from '../models/general-specialty.model';
import { Language } from '../models/language.model';
import { OrgService } from '../org.service';

@Component({
  selector: 'app-org-reviewer-filter',
  templateUrl: './org-reviewer-filter.component.html',
  styleUrls: ['./org-reviewer-filter.component.scss']
})
export class OrgReviewerFilterComponent implements OnInit {
  @Output() onSearch = new EventEmitter<any>();
  @Output() onClear = new EventEmitter<void>();
  filtersForm: FormGroup;
  isLoadingResults = true;

  gender = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' }
  ];

  residencePlace = [
    { value: 'local', label: 'Local' },
    { value: 'international', label: 'International' }
  ];
  nationalities$: Observable<Country[]> = this.orgService.getCountries()
    .pipe(finalize(() => this.isLoadingResults = false));
  localResidenceCity$: Observable<GeneralSpecialty[]> = this.orgService.getLocalResidenceCity();
  languages$: Observable<Language[]> = this.orgService.getLanguages();
  generalSpecialty$: Observable<GeneralSpecialty[]> = this.orgService.getGeneralSpecialty();

  constructor(private fb: FormBuilder,
    private orgService: OrgService) { }

  ngOnInit() {
    this.initFilterForm();
  }

  search() {
    const values = this.filtersForm.value;
    this.onSearch.emit({
      ...(values.arabicName ? { 'arabicName.contains': values.arabicName } : {}),
      ...(values.englishName ? { 'englishName.contains': values.englishName } : {}),
      ...(values.mainEmail ? { 'mainEmail.contains': values.mainEmail } : {}),
      ...(values.gender ? { 'gender.equals': values.gender } : {}),
      ...(values.nationality ? { 'nationality.equals': values.nationality } : {}),
      ...(values.residenceCountry ? { 'residenceCountry.equals': values.residenceCountry } : {}),
      ...(values.residencePlace ? { 'residencePlace.equals': values.residencePlace } : {}),
      ...(values.localResidenceCity ? { 'residenceCity.equals': values.localResidenceCity } : {}),
      ...(values.workDestination ? { 'workDestination.contains': values.workDestination } : {}),
      ...(values.language ? { 'language.contains': values.language } : {}),
      ...(values.delicateSpecialization ? { 'delicateSpecialization.contains': values.delicateSpecialization } : {}),
      ...(values.generalSpecialty ? { 'generalSpecialty.equals': values.generalSpecialty } : {}),
      ...(values.reviewerState ? { 'reviewerState.equals': values.reviewerState } : {}),
    });
  }
  clear() {
    this.filtersForm.reset();
    this.onClear.emit();
  }

  private initFilterForm(): void {
    this.filtersForm = this.fb.group({
      arabicName: new FormControl(''),
      englishName: new FormControl(''),
      mainEmail: new FormControl(''),
      gender: new FormControl(''),
      nationality: new FormControl(''),
      residenceCountry: new FormControl(''),
      residencePlace: new FormControl(''),
      localResidenceCity: new FormControl(''),
      workDestination: new FormControl(''),
      language: new FormControl(''),
      delicateSpecialization: new FormControl(''),
      generalSpecialty: new FormControl(''),
      reviewerState: new FormControl(''),
    });
  }
}
